import { FETCH_SURVEY_STATUS, UPDATE_SURVEY } from "../../actions/actionTypes";

const surveyReducer = (state = {}, action) => {
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch (action.type) {
            case FETCH_SURVEY_STATUS:
                return {
                    ...state,
                    isSurveyCompleted: action.payload.isSurveyCompleted || false,
                    surveyQuestions: action.payload.surveyQuestions || [],
                    errors: action.errors || null,
                };
            case UPDATE_SURVEY:
                return {
                    ...state,
                    ...action.payload,
                    errors: action.errors || null,
                };
            default:
                return state;
        }
    }
    return state;
    
};

export default surveyReducer;
